import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const HR_TOKEN_KEY = "r2w_hr_token";

const hrApi = axios.create({ baseURL: `${BASE}/api/hr` });

hrApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(HR_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

hrApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !String(err.config?.url || "").includes("/public/")) {
      localStorage.removeItem(HR_TOKEN_KEY);
      if (!window.location.pathname.startsWith("/hr/")) window.location.assign("/hr");
    }
    return Promise.reject(err);
  }
);

export default hrApi;
